import 'bootstrap/dist/js/bootstrap'
import logo from '../assets/images/linket-logo-small.png'

export default function Footer(){
   return (
        <footer className="position-absolute bottom-0 d-flex flex-wrap justify-content-between align-items-center py-2 my-0 border-top">
            <div className="col-md-4 d-flex align-items-center">
                <a href="/" className="text-muted text-decoration-none lh-1">
                    <img className='img-fluid' width="100" src={logo} alt="logo"></img>
                </a>
            </div>

            <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
                <li className="ms-3"><a className="text-dark" href="https://wa.link/gxszrh" target='_blank' rel="noreferrer"><i className="zmdi zmdi-whatsapp zmdi-hc-2x"></i></a></li>
                <li className="ms-3"><a className="text-dark" href="https://instagram.com/linket.me" target='_blank' rel="noreferrer" ><i className="zmdi zmdi-instagram zmdi-hc-2x"></i></a></li>
                <li className="ms-3"><a className="text-dark" href="tel:00989133394325"><i className="zmdi zmdi-phone zmdi-hc-2x"></i></a></li>
            </ul>
        </footer>
   )
}